
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * PushNotificationEventType enum
 */
class PushNotificationEventType {
  /**
   * Initialize enum with a given value
   * @param {PushNotificationEventType|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof PushNotificationEventType) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!PushNotificationEventType}
   * @param {!PushNotificationEventType} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof PushNotificationEventType)) {
      throw new TypeError('Instance of PushNotificationEventType is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!PushNotificationEventType}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!PushNotificationEventType}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === PushNotificationEventType.ACTIVATION.value) {
      return 'ACTIVATION'
    }
    if (this.value === PushNotificationEventType.TAKE_PROFIT.value) {
      return 'TAKE_PROFIT'
    }
    if (this.value === PushNotificationEventType.STOP_LOSS.value) {
      return 'STOP_LOSS'
    }
    if (this.value === PushNotificationEventType.MARGIN_CALL.value) {
      return 'MARGIN_CALL'
    }
    if (this.value === PushNotificationEventType.STOP_OUT.value) {
      return 'STOP_OUT'
    }
    if (this.value === PushNotificationEventType.DEPOSIT.value) {
      return 'DEPOSIT'
    }
    if (this.value === PushNotificationEventType.WITHDRAWAL.value) {
      return 'WITHDRAWAL'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!PushNotificationEventType}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!PushNotificationEventType}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!PushNotificationEventType} Created enum
   */
  static fromObject (other) {
    return new PushNotificationEventType(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
PushNotificationEventType.ACTIVATION = new PushNotificationEventType(1 + 0)
// noinspection PointlessArithmeticExpressionJS
PushNotificationEventType.TAKE_PROFIT = new PushNotificationEventType(2 + 0)
// noinspection PointlessArithmeticExpressionJS
PushNotificationEventType.STOP_LOSS = new PushNotificationEventType(4 + 0)
// noinspection PointlessArithmeticExpressionJS
PushNotificationEventType.MARGIN_CALL = new PushNotificationEventType(8 + 0)
// noinspection PointlessArithmeticExpressionJS
PushNotificationEventType.STOP_OUT = new PushNotificationEventType(16 + 0)
// noinspection PointlessArithmeticExpressionJS
PushNotificationEventType.DEPOSIT = new PushNotificationEventType(32 + 0)
// noinspection PointlessArithmeticExpressionJS
PushNotificationEventType.WITHDRAWAL = new PushNotificationEventType(64 + 0)

export { PushNotificationEventType };

/**
 * Fast Binary Encoding PushNotificationEventType field model
 */
class FieldModelPushNotificationEventType extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelPushNotificationEventType}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the value
   * @this {!FieldModelPushNotificationEventType}
   * @param {PushNotificationEventType=} defaults Default value, defaults is new PushNotificationEventType()
   * @returns {!PushNotificationEventType} Result value
   */
  get (defaults = new PushNotificationEventType()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new PushNotificationEventType(this.readInt32(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelPushNotificationEventType}
   * @param {!PushNotificationEventType} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeInt32(this.fbeOffset, value.value)
  }
}

export { FieldModelPushNotificationEventType };
